import React, { Component } from 'react';
import imgLoading from '../../../assets/itemLoading.gif';
import Swal from 'sweetalert2'


class Imgloading extends Component {

    state = { 
        loading: true,
        onError: false,
     }

    img = this.props.Img;

    handleLoad = e => {
        this.setState({loading: false});
    }

    handleError = e => {
        this.setState({loading: false});
        this.setState({onError: true});
    }

    showImage = (img) => {
        
        Swal.fire({
            imageUrl: img,
            imageAlt: 'image',
            backdrop:true,
          })
    }
    
    render() {
        return (
            <>
                { this.state.loading && <img src={imgLoading}></img> }
                <img 
                    style={this.state.onError ? {display: 'none'} : {}}
                    src={this.img} 
                    onLoad={this.handleLoad} 
                    onError={this.handleError}
                    onClick={ () => this.showImage(this.img) }
                    ></img>
                {this.state.onError && <img src={imgLoading}></img>}
            </>
        );
    }
}

export default Imgloading;